export default "__VITE_ASSET__b0e4352f__"